import { createSvgIcon } from '@mui/material/utils'

export const CompassIcon = createSvgIcon(
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M10 3.33268C8.84941 3.33268 7.91667 4.26542 7.91667 5.41602C7.91667 6.56661 8.84941 7.49935 10 7.49935C11.1506 7.49935 12.0833 6.56661 12.0833 5.41602C12.0833 4.26542 11.1506 3.33268 10 3.33268ZM10 3.33268V1.66602M17.5 12.4472C15.6676 14.5233 12.9867 15.8327 10 15.8327C7.01327 15.8327 4.33236 14.5233 2.5 12.4472M8.95402 7.21742L2.5 18.3327M11.046 7.21742L17.5 18.3327' stroke-width='1.67' stroke-linecap='round' stroke-linejoin='round' />
  </svg>
)
